import {MoneyFormat} from "./MoneyFormat";

export function MoneyField() {
    return {
        className: 'money-field',
        onRender: (item, any, index) => {
                return MoneyFormat(item[index.key]);
        }
    }
}